<div class="modal-header" mat-dialog-title>
    <div class="modal-header-icon">
        <mat-icon class="material-symbols-outlined">percent</mat-icon>
    </div>
    <div class="modal-header-titles">
        <h2 class="modal-title">Editar alíquota</h2>
        <span class="modal-subtitle">{{ data.descricao }}</span>
    </div>
    <div class="modal-header-close-btn-container">
        <button mat-icon-button type="button" class="modal-close-btn" (click)="fechar()">
            <mat-icon class="material-symbols-outlined">close</mat-icon>
        </button>
    </div>
</div>

<mat-dialog-content class="modal-content">
    <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
        <mat-label>{{ data.titulo }} (%)</mat-label>
        <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask4" [(ngModel)]="valor" (keydown.enter)="salvar()">
    </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
    <button mat-stroked-button class="btn-secondary" type="button" (click)="fechar()">Cancelar</button>
    <button mat-flat-button class="btn-primary" type="button" [disabled]="invalido" (click)="salvar()">Salvar</button>
</mat-dialog-actions>
